<!--
 * @Author: Junchi Zhao
 * @LastEditors: 金经义 jinjy@epsoft.com.cn
 * @Description: 基础流程布局组件
-->
<template>
  <div class="baseFlowLayout pcth100 df">
    <div class="head" v-if="headShow">
      <div class="bread">
        <span class="breadLabel">任务名称：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{ flowName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="flexBlank">
        <!-- 步骤条 -->
        <div v-for="item in module_type_1" :key="item.moduleName">
          <el-button type="primary" round @click="openDilog(item)">{{
            item.moduleTitle
          }}</el-button>
        </div>

        <div>
          <el-button
            v-for="item in module_type_2"
            :key="item.moduleName"
            type="primary"
            round
            plain
            @click="openDilog(item)"
            >{{ item.moduleTitle }}</el-button
          >
        </div>
      </div>
      <!-- <div class="flexBlank"></div> -->
      <div class="btnBox" v-if="btnShow">
        <!-- 额外按钮 -->
        <slot name="btns" />
        <template v-for="(item, index) in btnList">
          <el-button
            v-if="item && item.show == 1 && index == 5 && isTasked == 2"
            type="danger"
            :key="index"
            @click="defaultZuofeiDilog"
            >{{ item.text ? item.text : '作废' }}</el-button
          >
          <el-button
            v-if="item && item.show == 1 && index == 0 && editStatus == 1 && batchSubmit != 1"
            :key="index"
            type="primary"
            @click="defaultSave"
            :loading="saveloading"
            >{{ item.text ? item.text : '保存' }}</el-button
          >
          <el-button
            v-if="item && item.show == 1 && index == 1 && isTasked == 2"
            type="success"
            :key="index"
            @click="defaultSubmit"
            :loading="commitloading"
            >{{ item.text ? item.text : '提交' }}</el-button
          >
          <el-button
            v-if="item && item.show == 1 && index == 2 && isTasked == 2"
            type="warning"
            :key="index"
            @click="defaultTuihuiDilog"
            >{{ item.text ? item.text : '退回' }}</el-button
          >
          <el-button
            v-if="item && item.show == 1 && index == 3 && isTasked == 2"
            type="danger"
            :key="index"
            @click="defaultBohuiDilog"
            >{{ item.text ? item.text : '驳回' }}</el-button
          >
          <el-button
            v-if="item && item.show == 1 && index == 4"
            type="default"
            :key="index"
            @click="defaultGoBack"
            >{{ item.text ? item.text : '返回' }}</el-button
          >
          <el-button
            v-if="item && item.show == 1 && index == 6"
            type="primary"
            :key="index"
            @click="$emit('btnClick', item.text)"
            >{{ item.text ? item.text : '预览' }}</el-button
          >
        </template>
      </div>
    </div>

    <div class="fg1 ova mt10 rel">
      <div
        style="overflow-y: auto"
        :style="{ 'max-height': showOpinion ? 'calc(100vh - 280px)' : '100%' }"
      >
        <!-- 内容主体 -->
        <slot name="flowBody" :nodeParams="nodeParams" />
      </div>
      <!-- 意见列表 -->
      <div v-if="showOpinion">
        <el-divider content-position="left">意见信息</el-divider>
        <el-form
          class="dataform"
          :model="form"
          :rules="rules"
          ref="form"
          label-width="180px"
          label-position="right"
        >
          <div :key="index" v-for="(item, index) in form.opinions">
            <el-form-item
              :label="item.opinionName"
              :prop="'opinions.' + index + '.opinionContent'"
              :rules="{
                required: true,
                message: item.opinionName + '不能为空',
                trigger: 'blur'
              }"
            >
              <el-input
                class="pctw100"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 8 }"
                placeholder="请输入"
                v-model="item.opinionContent"
              >
              </el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="结论" prop="conclusion">
              <el-radio-group v-model="form.conclusion" @click.native="test">
                <el-radio
                  v-for="(item, index) in conclusionList"
                  :key="index"
                  :label="item.conclusion"
                  >{{ item.conclusionName }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog
      :visible.sync="centerDialogVisible"
      v-if="centerDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
      :center="true"
    >
      <tips :dataList="dataList" :returnMessage="returnMessage" @closeTips="goback"></tips>
    </el-dialog>
    <el-dialog
      :visible.sync="errorDialogVisible"
      v-if="errorDialogVisible"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
      :center="true"
    >
      <errortips :dataList="dataList" @closeTips="goback"></errortips>
    </el-dialog>
    <el-dialog
      title="作废"
      :visible.sync="defaultzuofeiVisible"
      v-if="defaultzuofeiVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
    >
      <el-form
        ref="defaultBackForm"
        :model="chooseBackForm"
        label-width="120px"
        :rules="defaultBackRule"
      >
        <el-form-item label="作废意见" prop="opinion">
          <el-input type="textarea" v-model="chooseBackForm.opinion" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="defaultzuofeiVisible = false">取 消</el-button>
        <el-button type="primary" :loading="zuofeiLoading" @click="defaultZuofei">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="退回"
      :visible.sync="defaultBackVisible"
      v-if="defaultBackVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
    >
      <el-form
        ref="defaultBackForm"
        :model="chooseBackForm"
        label-width="120px"
        :rules="defaultBackRule"
      >
        <el-form-item label="退回意见" prop="opinion">
          <el-input type="textarea" v-model="chooseBackForm.opinion" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="defaultBackVisible = false">取 消</el-button>
        <el-button type="primary" :loading="tuihuiLoading" @click="defaultTuihui">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="驳回"
      :visible.sync="defaultbohuiVisible"
      v-if="defaultbohuiVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
    >
      <el-form
        ref="defaultBackForm"
        :model="chooseBackForm"
        label-width="120px"
        :rules="defaultBackRule"
      >
        <el-form-item label="驳回意见" prop="opinion">
          <el-input type="textarea" v-model="chooseBackForm.opinion" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="defaultbohuiVisible = false">取 消</el-button>
        <el-button type="primary" :loading="bohuiLoading" @click="defaultbohui">确 定</el-button>
      </span>
    </el-dialog>
    <jh-base-dialog
      :visible.sync="approvalDialogVisible"
      title="审批意见"
      width="600"
      @close="approvalClose"
    >
      <template slot="footer">
        <jh-button icon="cancel" type="default" @click="approvalClose">取 消</jh-button>
        <jh-button type="primary" icon="confirm" :loading="approvalLoading" @click="approvalSubmit"
          >确 定</jh-button
        >
      </template>
    </jh-base-dialog>
    <progressComponent
      :is-dialog="true"
      :visible.sync="fetchInfoDialogVisible"
      :title="fetchInfoDialogConfig.title || '流程进展'"
      :attr="fetchInfoDialogConfig.requestData"
      v-if="fetchInfoDialogVisible"
    ></progressComponent>
  </div>
</template>

<script>
import tips from '@/components/tips/index.vue';
import errortips from '@/components/tips/error.vue';
import progressComponent from '@/views/flow/diagram/progressComponent.vue';
export default {
  name: 'baseFlowLayout',
  components: {
    tips,
    errortips,
    progressComponent
  },
  props: {
    //三个按钮顺序依次为保存 提交 返回 1显示 不传为隐藏 例:['','',{text:"返回",show:1}] 为仅显示返回按钮
    btnShow: {
      type: Boolean,
      default: () => true
    },
    headShow: {
      type: Boolean,
      default: () => true
    },
    btnList: {
      type: Array,
      default: () => [
        { text: '保存', show: 1 },
        { text: '提交', show: 1 },
        { text: '退回', show: 1 },
        { text: '驳回', show: 1 },
        { text: '返回', show: 1 },
        { text: '作废', show: 2 }
      ]
    },
    flowName: {
      type: String,
      default: () => ''
    },
    save: Function, //保存方法
    submit: Function, //提交方法
    tuihui: Function, //退回
    bohui: Function, //驳回
    goBack: Function, //返回方法
    zuofei: Function //作废方法
  },

  data() {
    return {
      saveloading: false,
      commitloading: false,
      approvalLoading: false,
      bohuiLoading: false,
      zuofeiLoading: false,
      tuihuiLoading: false,
      approvalDialogVisible: false,
      rules: {},
      showOpinion: false,
      fetchInfoDialogConfig: {
        title: '',
        componentName: '',
        requestData: ''
      },
      fetchInfoDialogVisible: false,
      options: [],
      nodeParams: {},
      flowParams: {},
      instanceId: '',
      taskId: '',
      nodeId: '',
      module_type_1: [],
      module_type_2: [],
      defaultBackRule: {
        opinion: [
          {
            required: true,
            message: '请填写意见',
            trigger: ['blur', 'submit']
          }
        ]
      },
      defaultzuofeiVisible: false,
      defaultbohuiVisible: false,
      defaultBackVisible: false,
      dataList: [],
      returnMessage: '', //接口成功返回提示语
      errorDialogVisible: false,
      centerDialogVisible: false,
      editStatus: this.$route.query.editStatus ? this.$route.query.editStatus : 1,
      isTasked: this.$route.query.isTasked ? this.$route.query.isTasked : 2,
      batchSubmit: this.$route.query.batchSubmit ? this.$route.query.batchSubmit : '',
      chooseBackForm: {
        nodeKey: this.$route.query.taskDefKey,
        instanceId: this.$route.query.instanceId,
        taskId: this.$route.query.taskId,
        taskDefKey: this.$route.query.taskDefKey,
        taskName: this.$route.query.taskName,
        opinion: ''
      },
      form: {
        opinions: [],
        conclusionName: '通过',
        conclusion: '1',
        taskId: this.$route.query.taskId,
        instanceId: this.$route.query.instanceId,
        taskDefKey: this.$route.query.taskDefKey,
        taskName: this.$route.query.taskName
      },
      conclusionList: []
    };
  },

  computed: {},

  async created() {
    await this.getNodeParams();
    await this.getFlowParams();
    this.opinionInit();
  },
  mounted() {
    // this.$loadingMask.show(
    //   {
    //     preset: 'loading'
    //   },
    //   this.$el //设置遮罩层绑定的元素
    // );
  },

  methods: {
    //工具条打开公共窗口
    openDilog(item) {
      if (item.isEdit == '2') {
        this.flowParams.readOnly = true;
      } else {
        this.flowParams.readOnly = false;
      }
      this.fetchInfoDialogConfig.title = item.moduleTitle;
      this.fetchInfoDialogConfig.componentName = item.moduleName;
      this.fetchInfoDialogConfig.requestData = {
        ...this.flowParams,
        instanceId: this.$route.query.instanceId,
        name: item.moduleName
      };
      this.fetchInfoDialogConfig.isFull = true;
      this.fetchInfoDialogVisible = true;
    },
    /**
     * 根据节点id获取节点配置信息
     */
    getNodeParams() {
      console.log('getNodeParams');
      return new Promise((resolve) => {
        const params = {
          nodeId: this.$route.query.nodeId,
          instanceId: this.$route.query.instanceId,
          taskDefKey: this.$route.query.taskDefKey
        };
        this.$api.formPost('/api/flow/deploy/flowNode/doGetInfo', params).then((res) => {
          if (res.retHead.code == '0000000') {
            this.nodeParams = res.retBody;
          }
          resolve();
        });
      });
    },
    getFlowParams() {
      return new Promise((resolve) => {
        if (!this.$route.query.instanceId) {
          resolve();
        }
        const params = {
          instanceId: this.$route.query.instanceId
        };
        this.$api.formPost('/api/flow/history/getFlowParam', params).then((res) => {
          if (res.retHead.code == '0000000') {
            this.flowParams = { ...this.flowParams, ...res.retBody };
            this.flowParams.instanceId = this.$route.query.instanceId;
            if (
              typeof this.$route.query.editStatus != 'undefined' &&
              this.$route.query.editStatus != null
            ) {
              this.flowParams['editStatus'] = this.$route.query.editStatus;
            }
            this.show = true;
          }
          resolve();
        });
      });
    },
    /**
     * 意见初始化
     */
    async opinionInit() {
      if (this.nodeParams) {
        if (this.nodeParams.nodeInfo.showOpinionNodekeys) {
          this.showOpinionList = true;
        }
        if (this.nodeParams.nodeInfo.isConclusion == '1') {
          this.showConclusion = true;
          this.conclusionList = this.nodeParams.nodeInfo.conclusionList;
        }
        if (this.nodeParams.modules) {
          if (this.nodeParams.modules.module_type_1) {
            this.module_type_1 = this.nodeParams.modules.module_type_1;
          }
          if (this.nodeParams.modules.module_type_2) {
            this.module_type_2 = this.nodeParams.modules.module_type_2;
          }
        }
        if (this.nodeParams.nodeInfo.isOpinion == '1') {
          this.showOpinion = true;
        }
        this.opinions = [];
        if (this.nodeParams.opinions) {
          const list = await this.getOpinionAllByTaskId();
          for (let i = 0; i < this.nodeParams.opinions.length; i++) {
            const opinion = {
              opinionName: this.nodeParams.opinions[i].label,
              instanceid: this.$route.query.instanceId,
              taskid: this.$route.query.taskId,
              taskDefKey: this.$route.query.taskDefKey,
              taskName: this.$route.query.taskName,
              opinionContent: '通过'
            };
            if (list && list.length > 0) {
              for (let j = 0; j < list.length; j++) {
                // eslint-disable-next-line max-depth
                if (list[j].opinionName == opinion.opinionName) {
                  opinion.id = list[j].id;
                  opinion.opinionContent = list[j].opinionContent;
                }
              }
            }
            this.opinions.push(opinion);
          }

          this.form.opinions = this.opinions;
        }
      }
      this.$emit('init');
      // this.$loadingMask.hide();
    },
    test(row) {
      if (row.srcElement.labels) {
        this.form.conclusionName = row.srcElement.labels[0].innerText;
        for (let i = 0; i < this.form.opinions.length; i++) {
          this.form.opinions[i].opinionContent = this.form.conclusionName;
        }
      }
    },
    //根据任务id获取保存的意见列表
    // eslint-disable-next-line require-await
    async getOpinionAllByTaskId() {
      return new Promise((resolve) => {
        this.$api
          .formPost('/api/flow/projectOpinion/doGetAllListByTaskId', {
            taskid: this.$route.query.taskId
          })
          .then((res) => {
            if (res.retHead.code == '0000000') {
              resolve(res.retBody);
            }
          });
      });
    },
    defaultTuihuiDilog() {
      this.defaultBackVisible = true;
    },
    defaultBohuiDilog() {
      this.defaultbohuiVisible = true;
    },
    defaultZuofeiDilog() {
      this.defaultzuofeiVisible = true;
    },
    defaultZuofei() {
      this.$refs.defaultBackForm.validate((valid) => {
        if (valid) {
          if (typeof this.zuofei === 'function') {
            this.zuofeiLoading = true;
            this.zuofei().then((res) => {
              this.zuofeiLoading = false;
              if (res.retHead.code == '0000000') {
                this.defaultzuofeiVisible = false;
                this.$message.success('作废成功！');
                this.defaultGoBack();
              }
            });
          } else {
            this.$message.error('未设置作废方法!');
          }
        }
      });
    },
    goback() {
      //立即返回
      history.go(-1);
    },
    //默认保存方法
    defaultSave() {
      if (typeof this.save === 'function') {
        if (this.showOpinion) {
          //this.$refs['form'].validate((valid) => {
          //if (valid) {
          this.saveloading = true;
          this.save().then((res) => {
            this.saveloading = false;
            console.log(res);
            if (res.retHead.code === '0000000') {
              this.opinionInit();
            }
          });
          //}
          //});
        } else {
          this.save().then((res) => {
            this.saveloading = false;
            if (res.status === '0') {
              this.opinionInit();
            }
          });
        }
      } else {
        throw new Error('未设置 save 方法!');
      }
    },
    approvalClose() {
      this.approvalDialogVisible = false;
    },
    approvalSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (typeof this.submit === 'function') {
            this.approvalLoading = true;
            this.submit()
              .then((res) => {
                this.approvalLoading = false;
                this.approvalDialogVisible = false;
                if (res.retHead.code === '0000000') {
                  if (res.retBody) {
                    if (res.retBody.errorList) {
                      this.dataList = res.retBody.errorList;
                      this.errorDialogVisible = true;
                    } else {
                      this.dataList = res.retBody.nextTaskUsers;
                      if (res.retBody.returnMessage) {
                        this.returnMessage = res.retBody.returnMessage;
                      }
                      this.centerDialogVisible = true;
                    }
                  }
                }
              })
              .catch(() => {
                this.approvalLoading = false;
                this.approvalDialogVisible = false;
              });
          } else {
            throw new Error('未设置 submit 方法!');
          }
        }
      });
    },
    //默认提交方法
    defaultSubmit() {
      if (typeof this.submit === 'function') {
        this.commitloading = true;
        this.submit().then((res) => {
          this.commitloading = false;
          if (res.retHead.code === '0000000') {
            if (res.retBody) {
              if (res.retBody.errorList) {
                this.dataList = res.retBody.errorList;
                this.errorDialogVisible = true;
              } else {
                this.dataList = res.retBody.nextTaskUsers;
                console.log(this.dataList);
                if (res.retBody.returnMessage) {
                  this.returnMessage = res.retBody.returnMessage;
                }
                this.centerDialogVisible = true;
              }
            }
          }
        });
      } else {
        throw new Error('未设置 submit 方法!');
      }
    },
    //默认退回方法
    defaultTuihui() {
      this.$refs.defaultBackForm.validate((valid) => {
        if (valid) {
          if (typeof this.tuihui === 'function') {
            this.tuihuiLoading = true;
            this.tuihui().then((res) => {
              this.tuihuiLoading = false;
              if (res.retHead.code == '0000000') {
                this.defaultBackVisible = false;
                this.$message.success('退回成功！');
                this.defaultGoBack();
              }
            });
          } else {
            return new Promise((resolve) => {
              if (!this.$route.query.instanceId) {
                resolve();
              }
              const params = {
                taskId: this.$route.query.taskId,
                instanceId: this.$route.query.instanceId,
                opinion: this.chooseBackForm.opinion
              };
              this.$api.formPost('/api/flow/workFlow/workFlowDefaultBack', params).then((res) => {
                if (res.retHead.code == '0000000') {
                  this.defaultBackVisible = false;
                  this.$message.success('退回成功！');
                  this.defaultGoBack();
                }
                resolve();
              });
            });
          }
        }
      });
    },
    //默认驳回方法
    defaultbohui() {
      this.$refs.defaultBackForm.validate((valid) => {
        if (valid) {
          if (typeof this.bohui === 'function') {
            this.bohuiLoading = true;
            this.bohui().then((res) => {
              this.bohuiLoading = false;
              if (res.retHead.code == '0000000') {
                this.defaultbohuiVisible = false;
                this.$message.success('驳回成功！');
                this.defaultGoBack();
              }
            });
          } else {
            return new Promise((resolve) => {
              if (!this.$route.query.instanceId) {
                resolve();
              }
              const params = {
                taskId: this.$route.query.taskId,
                instanceId: this.$route.query.instanceId,
                opinion: this.chooseBackForm.opinion
              };
              this.bohuiLoading = true;
              this.$api
                .formPost('/api/flow/workFlow/workFlowToStartStepBack', params)
                .then((res) => {
                  this.bohuiLoading = false;
                  if (res.retHead.code == '0000000') {
                    this.defaultbohuiVisible = false;
                    this.$message.success('驳回成功！');
                    this.defaultGoBack();
                  }
                  resolve();
                });
            });
          }
        }
      });
    },
    //默认返回方法
    defaultGoBack() {
      if (typeof this.goBack === 'function') {
        this.goBack();
      } else {
        history.go(-1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.baseFlowLayout {
  position: relative;
  display: flex;
  flex-direction: column;
  .head {
    display: flex;
    padding: 0px 20px;
    .bread {
      display: flex;
      align-items: center;
      margin-right: 32px;
      .breadLabel {
        font-size: 14px;
        line-height: 20px;
      }
    }
    .btnBox {
      padding-top: 10px;
    }
    .flexBlank {
      flex-grow: 1;
      display: flex;
      padding-top: 5px;
      .btn {
        margin-right: 15px;
      }
    }
    .line {
      border-right: 1px solid #dcdfe6;
    }
  }
}
::v-deep .el-breadcrumb__inner {
  font-weight: 900 !important;
}
.headTop {
  top: 0px;
}
::v-deep .el-divider__text {
  font-size: 16px;
  font-weight: bold;
}
.head {
  position: sticky;
  top: 0px;
  background: #fff;
  z-index: 999;
}
</style>
